const getJobGroupIdAndUserId = require('./get-job-group-id-user-id');

module.exports = { getJobGroupIdAndUserId };
